import React from "react";
import {
  Transition as ReactTransition,
  TransitionGroup
} from "react-transition-group";

import styled from "styled-components";

const timeout = 1500;

const TransitionElement = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 200vw;
  background-color: #07bd72;
  z-index: 1000;
  transform: translateX(50%);
  opacity: 1;
`;

const getWipeTransitionStyles = {
  exiting: {
    transition: `transform ${timeout}ms ease-in-out`,
    transform: `translateX(-100%)`
  }
};

const getTransitionStyles = {
  entering: {
    position: `absolute`,
    opacity: 0
  },
  entered: {
    transition: `opacity ${timeout / 2}ms ease-in-out`,
    opacity: 1
  },
  exiting: {
    transition: `opacity ${timeout / 2}ms ease-in-out`,
    opacity: 0.5
  }
};

class Transition extends React.PureComponent {
  render() {
    const { children, location } = this.props;

    return (
      <div>
        <TransitionGroup>
          <ReactTransition
            key={location.pathname}
            timeout={{
              enter: timeout / 2,
              exit: timeout / 2
            }}
          >
            {status => (
              <div
                style={{
                  ...getTransitionStyles[status]
                }}
              >
                {children}
              </div>
            )}
          </ReactTransition>
        </TransitionGroup>

        <TransitionGroup>
          <ReactTransition
            key={location.pathname}
            timeout={{
              enter: timeout,
              exit: timeout
            }}
          >
            {status => (
              <TransitionElement
                style={{
                  ...getWipeTransitionStyles[status]
                }}
              />
            )}
          </ReactTransition>
        </TransitionGroup>
      </div>
    );
  }
}

export { Transition };
